import { Fragment } from 'react';

import { BotMessage } from './BotMessage';
import { ContentInner, ContentWrapper } from './ChatContent.styles';
import { UserMessage } from './UserMessage';
import { ChatContentProps, ChatMessage } from './ChatContent.types';

const renderMessage = (message: ChatMessage) => {
  if (message.role === 'user' && message.text) {
    return (
      <UserMessage
        text={message.text}
        timestamp={message.createdAt}
      />
    );
  }

  return (
    <BotMessage
      text={message.text}
      tokens={message.tokens}
      isGenerating={message.isGenerating}
      timestamp={message.createdAt}
      error={message.error}
    />
  );
};

export const ChatContent = ({ messages, contentRef, onScroll }: ChatContentProps) => {
  const list = messages ?? [];

  return (
    <ContentWrapper
      ref={contentRef}
      onScroll={onScroll}
    >
      <ContentInner>
        {list.map(message => (
          <Fragment key={message.id}>{renderMessage(message)}</Fragment>
        ))}
      </ContentInner>
    </ContentWrapper>
  );
};
